import { GridPageChangeEvent } from "@progress/kendo-react-grid";
import React from "react";
import { Component, Position } from "puzzle";
import { get } from 'lodash';

function virtualScroll(GridComponent: any) {
  return class extends Component<any, any> {
    gridRef: any;

    constructor(props: any) {
      super(props);
      this.gridRef = React.createRef();
    };

    /**
     * Page event handler, set skip parameter
     */
    pageChange = (event: GridPageChangeEvent) => {
      const skip = event.page.skip;

      this.requestIfNeeded(skip);
      this.gridRef.setState({
        skip: skip
      });
    };

    /**
     * Call request for new page of data if needed
     */
    requestIfNeeded = (skip: number) => {
      const { pageSize } = this.gridRef.props;
      const { data, pageDataPopulated, pageNumber: lastPageNumber } = this.gridRef.state;
      for (let i = skip; i < skip + pageSize && i < data.length; i++) {
        if (!data[i].populated) {
          let pageNumber = Math.ceil((i + pageSize) / pageSize) - 1;
          if (pageNumber === lastPageNumber) {
            pageNumber--; //load previous page when scrolling up from down
          }
          if (!pageDataPopulated.includes(pageNumber)) {
            this.requestData(pageNumber);
          } else {
            //fix for scrolling up, don't allow to get stuck without data
            pageNumber--;
            if (!pageDataPopulated.includes(pageNumber)) {
              this.requestData(pageNumber);
            }
          }
          break;
        }
      }
    };

    /**
     * Request new page of data
     */
    requestData = (pageNumber: number) => {
      // request data only if not already fetched
      if (this.gridRef.state.requestInProgress) {
        //perform only one request at a time
        return;
      }

      let { pageDataPopulated } = this.gridRef.state;
      pageDataPopulated.push(pageNumber);
      this.gridRef.setState({ requestInProgress: true, pageNumber, pageDataPopulated },
        this.dispatch.bind(this, this.gridRef.props.requestActionName, Position.end, this.gridRef.prepareRequestParams(pageNumber)));
    };

    /**
     * Parse data and set it to grid
     */
    setGridData = (data: any) => {
      let { items = [], gridContentInfo, additionalInitData = {} } = data;
      let { data: stateData, pageNumber, skip, tasks } = this.gridRef.state;
      const { pageSize } = this.gridRef.props;
      if (items.length) {
        let total = gridContentInfo.totalCount;
        let newStateObj = {};
        let indexForAdd = pageSize * pageNumber;
        let allData;
        if (stateData.length === total) {
          allData = stateData;
        } else {
          Object.assign(newStateObj, { pageDataPopulated: [] });
          allData = new Array(total).fill(undefined, 0, total).map((e: any, i: number) => ({ Index: i, ...additionalInitData }));
        }
        let pagedListInfo = get(data.gridContentInfo, 'pagedListInfo');
        if (pagedListInfo) {
          let responsePageIndex = pagedListInfo.index;
          let tasksForPage = data.tasks;
          if (tasksForPage?.length && tasks) {//In some cases tasks in undefined (cancel submission) so we need to strengthen the condition not to set default to []
            tasks[responsePageIndex] = tasksForPage;
          }
          items.forEach((item: any, i: number) => {
            item.pageIndex = responsePageIndex;
            allData[indexForAdd] = { Index: indexForAdd, ...item, populated: true };
            indexForAdd++;
          });
        } else {
          items.forEach((item: any, i: number) => {
            allData[indexForAdd] = { Index: indexForAdd, ...item, populated: true };
            indexForAdd++;
          });
        }

        Object.assign(newStateObj, {
          data: allData,
          total: total,
          requestInProgress: false
        });
        if (tasks) {
          Object.assign(newStateObj, { tasks: tasks });
        }

        this.gridRef.setState(newStateObj);
      } else {
        this.gridRef.setState({
          requestInProgress: false,
          total: 0
        });
      }
      this.requestIfNeeded(skip);
    };

    VIRTUAL_SCROLL = {
      pageChange: this.pageChange,
      requestData: this.requestData,
      setGridData: this.setGridData,
      requestIfNeeded: this.requestIfNeeded
    };

    /**
     * Reference callback
     */
    refCallback = (ref: any) => {
      this.gridRef = ref;
      if (ref) {
        if (!ref.props.requestActionName) {
          throw new Error('requestActionName need to be defined in Grid Component');
        }

        if (!ref.prepareRequestParams) {
          throw new Error('prepareRequestParams Function need to be defined in Grid Component');
        }
      }
    };

    render() {
      return (
        <GridComponent {...this.props} ref={this.refCallback} virtualScroll={this.VIRTUAL_SCROLL} />
      )
    }
  }
}

export default virtualScroll;
